import { useContext, useRef, useState } from "react";
import "./Blog.css"
import { useLocation } from "react-router-dom";
import { LocaleContext } from "../common/App";
import { getBasePath, getBasePathTrailing, modifyAElesCustomer } from "../common/util";
import { BlogOverview } from "./BlogOverview";
import { ErrorComp, NavigateSmart } from "../common/Common";
import { BlogPost } from "../common/BlogPost";
import { BlogPostWrapper } from "./BlogPostWrapper";
import { useAutoLoad, useIndexUpdate, useModAEles } from "../common/hooks";
import { LoadState } from "../common/enums.mjs";
import { Footer } from "./WebsiteCommon";
import DOMPurify from "dompurify";
import { ConsumerContext } from "..";

export const Blog = ({indexUpdate}) => {
    const location = useLocation();

    const locale = useContext(LocaleContext);
    const consumer = useContext(ConsumerContext);


    const [postList, setPostList] = useState(null);


    // EFFECTS:

    const [loadState, setLoadState, resetLoading] = useAutoLoad((json) => {
        // On load success

        for(let post of json) {
            post.introduction_text_html = modifyAElesCustomer(DOMPurify.sanitize(post.introduction_text_html));
        }

        setPostList(json);
    }, () => {
        // On load error
    }, () => {

        return "/user/get_blog_post_list";
    }, [], true, false, false, false, true);

    useModAEles(consumer);

    useIndexUpdate(indexUpdate, locale);


    // RENDER:

    const rootPath = getBasePathTrailing(location.pathname);

    const overview = location.pathname === rootPath;

    let postId;

    if(!overview) {
        const searchParams = new URLSearchParams(location.search);
        postId = searchParams.get("id");
    }

    return (
        <div>
            { loadState === LoadState.LOAD_ERROR ?
                <div className="blog_content side_padding bottom_padding margin_top_low">
                    <ErrorComp text={locale.msgs.GENERAL_ERROR_DESCR}/>
                </div>
            : loadState === LoadState.LOAD_SUCCESS ?
                <div className="blog_content">
                    <div style={{ display: (overview ? null : "none")}}>
                        <BlogOverview postList={postList} />
                    </div>
                </div>
            :
                null
            }

            { overview ?
                null
            : location.pathname === rootPath + "post/" ?
                <BlogPostWrapper id={postId} />
            :
                <NavigateSmart to={rootPath} />
            }

            <Footer />

        </div>
    );
}
